import React from 'react';
import { ChartRendererSupabase } from './ChartRendererSupabase';

interface EVBarriersBarChartProps {
  chartData: any;
  chartOptions: any;
}

const EVBarriersBarChart: React.FC<EVBarriersBarChartProps> = ({ chartData, chartOptions }) => {
  return (
    <ChartRendererSupabase
      chartData={chartData}
      chartOptions={chartOptions}
      height="450px"
    />
  );
};

export default EVBarriersBarChart;
